





















import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    value: { type: String as () => string },
    disabled: { type: Boolean as () => boolean },
    loading: { type: Boolean as () => boolean },
  },
  computed: {
    attrs(): any {
      return {
        ...this.$attrs,
      };
    },
    listeners(): any {
      return {
        ...this.$listeners,
      };
    },
    internal: {
      get(): string {
        return this.value;
      },
      set(value: string) {
        this.$emit('input', value);
      },
    },
  },
  data(): {
    menu: boolean;
  } {
    return {
      menu: false,
    };
  },
});
